/* Galerie vidéos — lecture au clic + slider */
(function () {
  function toEmbedUrl(url) {
    if (!url) return '';
    var yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/);
    if (yt) return 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0';
    var vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vm) return 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=1';
    return url;
  }

  function playInline(thumb, src) {
    var wrap = document.createElement('div');
    wrap.className = 'vg__embed';
    if (/\.(mp4|webm|ogg)(\?.*)?$/i.test(src)) {
      wrap.innerHTML = '<video src="' + src + '" controls autoplay playsinline></video>';
    } else {
      wrap.innerHTML = '<iframe src="' + toEmbedUrl(src) + '" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
    }
    thumb.appendChild(wrap);
    thumb.setAttribute('data-vg-playing', '1');
  }

  function initSlider(root) {
    var track = root.querySelector('[data-vg-track]');
    var prev = root.querySelector('[data-vg-prev]');
    var next = root.querySelector('[data-vg-next]');
    if (!track || !prev || !next) return;

    function step() {
      var item = track.querySelector('.vg__item');
      var gap = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '16', 10) || 16;
      return item ? item.getBoundingClientRect().width + gap : track.clientWidth;
    }
    function refresh() {
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', refresh, { passive: true });
    window.addEventListener('resize', refresh);
    refresh();
  }

  function init(root) {
    if (!root || root.__vgInit) return;
    root.__vgInit = true;

    root.querySelectorAll('[data-vg-play]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.getAttribute('data-vg-playing')) return;
        playInline(btn, btn.getAttribute('data-vg-src'));
      });
    });

    if (root.classList.contains('vg--slider')) initSlider(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-vg]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
